import axios from 'axios';

// Use the proxy URL instead of direct server URL
const API_URL = 'http://localhost:3001/api';

const blogService = {
  // Get all posts
  getAllPosts: async () => {
    try {
      const response = await axios.get(`${API_URL}/posts`);
      return response.data;
    } catch (error) {
      console.error('Error fetching posts:', error);
      throw new Error('Failed to fetch posts');
    }
  },

  // Get a single post by ID
  getPostById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/posts/${id}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch post');
    }
  },

  // Create a new post
  createPost: async (postData) => {
    try {
      console.log('Sending request to:', `${API_URL}/posts`);
      const response = await axios.post(`${API_URL}/posts`, postData);
      return response.data;
    } catch (error) {
      console.error('Blog service error:', error.response || error);
      throw error; // Re-throw the error to be handled by the component
    }
  },

  // Update a post
  updatePost: async (id, postData) => {
    try {
      const response = await axios.put(`${API_URL}/posts/${id}`, postData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update post');
    }
  },

  // Delete a post
  deletePost: async (id) => {
    try {
      await axios.delete(`${API_URL}/posts/${id}`);
      return true;
    } catch (error) {
      throw new Error('Failed to delete post');
    }
  }
};

export default blogService; 